/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Table } from 'antd';
import H3Text from '@Uilib/h3Text';
import './style.scss';
/**
 * PurchaseRequestLines component
 *
 * @param record
 * @param file
 */
class BulkPOLines extends Component {
  /**
   * Constructor
   *
   * @param props
   */
  constructor(props) {
    super(props);
    const innerLinkedPOsColumns = [
      {
        title: 'BUSINESS UNIT',
        width: '200px',
        render: (text, record) => record?.tenant_info?.tenant_name,
      },
      {
        title: 'QTY',
        dataIndex: 'quantity',
        width: '140px',
        render: (text, record) => (
          <H3Text text={record?.quantity ? record?.quantity : 0} />
        ),
      },
      {
        title: 'LINE TOTAL',
        width: '140px',
        render: (text, record) => (
          <H3Text text={this.props.MONEY(record?.total_price || 0)} />
        ),
      },
    ];
    this.state = {
      linkedPOsColumns: [
        {
          title: '#',
          width: '80px',
          render: (record) => (
            <div style={{ width: '60px' }}>
              <Link to={`/inventory/product/view/${record?.product_sku_id}`} target="_blank">
                {record?.internal_sku_code}
              </Link>
            </div>
          ),
        },
        {
          title: 'PRODUCT',
          width: '150px',
          render: (item) => (
            <div style={{ width: '130px' }}>
              <Fragment>
                {`${item?.product_sku_name}`}
              </Fragment>
            </div>
          ),
        },
        {
          title: 'UNIT',
          width: '60px',
          render: (item) => `${item?.uom_info?.[0]?.uqc?.toProperCase()}`,
        },
        {
          title: 'TAX',
          width: '80px',
          render: (record) => `${record?.tax_info?.tax_value}%`,
        },
        {
          title: 'BUSINESS UNIT',
          render: (record) => {
            const { getBulkPOByIdLoading } = this.props;
            return (
              <div className="bulk-po-inner-items-table">
                <Table
                  showHeader={false}
                  size="small"
                  scroll="scroll"
                  columns={innerLinkedPOsColumns}
                  dataSource={record?.tenants ? JSON.parse(JSON.stringify(record?.tenants)) : []}
                  pagination={false}
                  bordered
                  loading={getBulkPOByIdLoading}
                />
              </div>
            );
          },
          onCell: () => ({ colSpan: 7 }),
        },
        {
          title: 'QTY',
          width: '0px',
          render: () => (<div />),
          onCell: () => ({ colSpan: 0 }),
        },
        {
          title: 'LINE TOTAL',
          width: '0px',
          render: () => (<div />),
          onCell: () => ({ colSpan: 0 }),
        },
      ],
    };
  }

  /**
   *
   */
  componentDidMount() {

  }

  /**
   *
   * @return {*}
   */
  render() {
    const { linkedPOs } = this.props;
    const { linkedPOsColumns } = this.state;
    return (
      <Fragment>
        <div className="bulk-po-table-wrapper hide__in-mobile">
          <div style={{ display: 'flex', width: '100%' }}>
            <div className="bulk-po-items-table__header1">
              <div style={{ width: '80px' }}>#</div>
              <div style={{ width: '150px' }}>PRODUCT</div>
              <div style={{ width: '60px' }}>UNIT</div>
              <div style={{ width: '80px' }}>TAX</div>
            </div>
            <div className="bulk-po-items-table__header2" style={{ justifyContent: 'space-between', width: '100%' }}>
              <div style={{ width: '50%' }}>BUSINESS UNIT</div>
              <div style={{ width: '31%' }}>QTY</div>
              <div style={{ width: '39%' }}>LINE TOTAL</div>
            </div>
          </div>
          <Table
            bordered
            showHeader
            size="small"
            columns={linkedPOsColumns}
            dataSource={linkedPOs || []}
            pagination={false}
            scroll={{ x: true }}
          />
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = ({ UserReducers }) => ({
  MONEY: UserReducers.MONEY,
});

const mapDispatchToProps = () => ({

});

BulkPOLines.propTypes = {
  linkedPOs: PropTypes.any,
  selectedBulkPO: PropTypes.any,
  getBulkPOByIdLoading: PropTypes.bool,

};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(BulkPOLines));
